import { forwardRef, type AnchorHTMLAttributes } from "react";
import Icon, { type IconName, type IconStyle } from "@react/widget/Icon";
import clsx from 'clsx';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  displayStyle?: string;
  icon?: boolean | IconName;
  iconStyle?: IconStyle;
  iconPosition?: "left" | "right";
};

const Link = forwardRef<HTMLAnchorElement, Props>(({icon = false, iconStyle, iconPosition = "right", className, displayStyle = "inline-block", children, ...props}, ref) => {
  const iconName:IconName = (typeof icon == "string") ? icon : "arrow-right-long";
  return (
  <a className={clsx("cursor-pointer w-fit transition hover:text-primary items-center [&>*]:align-middle", className)} {...props} ref={ref}>
    { (!!icon && iconPosition === "left") && <Icon className={clsx(!!children && "mr-1")} style={iconStyle} name={iconName}/> }
    { !!children && (!!icon ? (<span>{children}</span>) : children) }
    { (!!icon && iconPosition === "right") && <Icon className={clsx(!!children && "ml-1")} style={iconStyle} name={iconName}/> }
  </a>
  )
});

export default Link;